module.exports = __webpack_public_path__ + "static/media/messa2.60db45c8.webp";